<template>
    <div class="fhv-centent">
        <h4 class="title-topic">Auto Channel 5GHz</h4>
        <el-alert title="Some parameters in subRouter mode are forbidden to be modified!" type="warning" show-icon
        :closable="false" v-if="$G_DEVICE_CFG.isSubRouter"></el-alert>
        <el-form 
        label-width="50px" 
        label-position="left"
        size="mini"
        :disabled=" $G_DEVICE_CFG.isReadOnly || $G_DEVICE_CFG.isSubRouter"
        v-loading="getLoad"
        >
            <el-form-item>
                <el-radio v-model="autoChannelRadio" label="0">Thailand Standard(Recommend:Ch.36-64 and Ch.149-161)</el-radio>
            </el-form-item>
            <el-form-item>
                <el-radio v-model="autoChannelRadio" label="1">Customize</el-radio>
            </el-form-item>
            <el-form-item v-if="autoChannelRadio === '1'" >
                <div class="fh-cus">
                    <div class="fh-customize-band">
                        <el-checkbox v-model="band1Check" :indeterminate="isIndeterminate1" @change="handBandAll1">Band 1</el-checkbox>
                        <el-checkbox-group v-model="autoChannelArrT1" @change="handBand1" class="fh-channel-group">
                            <el-checkbox :label="channel" v-for="channel in band1" :key="channel">Channel {{channel}}</el-checkbox>
                        </el-checkbox-group>
                    </div>
                    <div class="fh-customize-band">
                        <el-checkbox v-model="band2Check" :indeterminate="isIndeterminate2" @change="handBandAll2">Band 2</el-checkbox>
                        <el-checkbox-group v-model="autoChannelArrT2" @change="handBand2" class="fh-channel-group">
                            <el-checkbox :label="channel" v-for="channel in band2" :key="channel">Channel {{channel}}</el-checkbox>
                        </el-checkbox-group>
                    </div>
                    <div class="fh-customize-band">
                        <el-checkbox v-model="band3Check" :indeterminate="isIndeterminate3" @change="handBandAll3">Band 3</el-checkbox>
                        <el-checkbox-group v-model="autoChannelArrT3" @change="handBand3" class="fh-channel-group">
                            <el-checkbox :label="channel" v-for="channel in band3" :key="channel">Channel {{channel}}</el-checkbox>
                        </el-checkbox-group>
                    </div>
                </div>
                
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="setData">Apply</el-button>
                <el-button type="primary" @click="getData">Refresh</el-button>
            </el-form-item>
        </el-form>
    </div>
</template>

<script> 
    const aisAotuChannel = [
        [36,40,44,48,52,56,60,64],
        [100,104,108,112,116,120,124,128],
        [149,153,157,161],
    ]
    const bitToChannel = [
        36,40,44,48,52,56,60,64,100,104,108,112,116,120,124,128,132,136,140,144,149,153,157,161
    ]
    const bit = [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0]
    const channelBit = {
        '36':0,'40':1,'44':2,'48':3,'52':4,'56':5,'60':6,'64':7,
        '100':8,'104':9,'108':10,'112':11,'116':12,'120':13,'124':14,'128':15,
        '149':20,'153':21,'157':22,'161':23
    }
    export default {
        data() {
            return {
                getLoad:false,
                autoChannelRadio: '0',
                autoChannelArrT1:[],
                autoChannelArrT2:[],
                autoChannelArrT3:[],
                band1:aisAotuChannel[0],
                band2:aisAotuChannel[1],
                band3:aisAotuChannel[2],
                band1Check:false,
                band2Check:false,
                band3Check:false,
                isIndeterminate1:true,
                isIndeterminate2:true,
                isIndeterminate3:true
            }
        },
        created(){
            this.getData()
        },
        computed: {
            autoChannelArr() {
                return [].concat(this.autoChannelArrT1,this.autoChannelArrT2,this.autoChannelArrT3)
            }
        },
        methods: {
            handBand1(value) {
                let checkedCount = value.length;
                this.band1Check = checkedCount === this.band1.length;
                this.isIndeterminate1 = checkedCount > 0 && checkedCount < this.band1.length;
            },
            handBand2(value) {
                let checkedCount = value.length;
                this.band2Check = checkedCount === this.band2.length;
                this.isIndeterminate2 = checkedCount > 0 && checkedCount < this.band2.length;
            },
            handBand3(value) {
                let checkedCount = value.length;
                this.band3Check = checkedCount === this.band3.length;
                this.isIndeterminate3 = checkedCount > 0 && checkedCount < this.band3.length;
            },
            handBandAll1(value){
                this.autoChannelArrT1 = value ? aisAotuChannel[0] : [];
                this.isIndeterminate1 = false;
            },
            handBandAll2(value){
                this.autoChannelArrT2 = value ? aisAotuChannel[1] : [];
                this.isIndeterminate2 = false;
            },
            handBandAll3(value){
                this.autoChannelArrT3 = value ? aisAotuChannel[2] : [];
                this.isIndeterminate3 = false;
            },
            setCheck(channel_sum){
                for (var i = 0; i < 24; i++) {
                    if (parseInt(channel_sum) & (1 << i))
                    {
                        if(bitToChannel[i] <= 64)
                        {
                            this.autoChannelArrT1.push(bitToChannel[i])
                            this.handBand1(this.autoChannelArrT1)
                        }
                        else if(bitToChannel[i] < 132 && bitToChannel[i] > 64)
                        {
                            this.autoChannelArrT2.push(bitToChannel[i])
                            this.handBand2(this.autoChannelArrT2)
                        }
                        else if(bitToChannel[i] >= 149)
                        {
                            this.autoChannelArrT3.push(bitToChannel[i])
                            this.handBand3(this.autoChannelArrT3)
                        }
                    }
                        
                }
            },
            getData(){
                this.getLoad = true
                axios
                .post("/JSONAPI",{
                    cmdType:'GET_AIS_AUTO_CHANNEL',
                    wlIndex:0
                })
                .then((response)=>{
                    this.getLoad = false
                    if(response.data.ret === 0)
                    {
                        let channel_sum = response.data.channelNum
                        this.autoChannelRadio = channel_sum === 15728895 ? '0' : '1'
                        this.setCheck(channel_sum)
                    } 
                })
                
            },
            setData(){
                let autoChannelBit,bitArr
                if(this.autoChannelRadio === '1')
                {
                    bitArr = bit.concat()
                    this.autoChannelArr.forEach((e)=>{
                        bitArr[channelBit[e]] = 1
                    })
                    autoChannelBit = parseInt(bitArr.reverse().join(''),2)
                    if(0 === autoChannelBit)
                    {
                        this.$message.error("Please select at least one channel!")
                    }
                }
                else
                {
                    autoChannelBit = 15728895
                }
                
                
                const loadingInstance = this.$loading({lock: true})
                axios
                .post("/JSONAPI",{
                    cmdType:'SET_AIS_AUTO_CHANNEL',
                    channelNum:autoChannelBit,
                    wlIndex:0
                })
                .then((response)=>{
                    setTimeout(()=>{
                        loadingInstance.close()
                        if(response.data.ret === 0)
                            this.$message.success("Configuration is successful!")
                        else
                            this.$message.error(`Configuration failed! Error:${response.data.errMsg}`)
                    },3000)
                })
            }
        },
    }
</script>

<style >
.fh-cus {
    display: flex;
    flex-direction: row;
    justify-content: space-around;
}

.fh-channel-group>.el-checkbox{
    display: block;
}
.fh-channel-group>.el-checkbox + .el-checkbox{
    margin-left: 0px;
}
</style>